<template>
  <section class="toucan" id="toucan">
    <div class="content">
      <!-- <span class="hi"> hello world! </span> -->
      <h3><span> TOUCAN</span></h3>
      <p class="info">todos, notes, budget</p>
      <p style="font-size:14px">
        Toucan; It is an application that aims to increase your productivity
        with the help of tasks, notes and budget modules in it.
      </p>
      <br />
      <div style="font-size:14px">
        <p>
          With Toucan, you can create a to-do list, set the date and time for
          each job, and take short notes. You can also share the work you wrote
          down by email and on social media with Whatsapp, Facebook, Twitter or
          Telegram applications.
        </p>
        <br />
        <p>
          Toucan is also a note taking program; You can keep and organize your
          notes, set categories and assign colors, as well as share them via
          email or popular social media platforms.
        </p>
        <br />
        <p>
          In addition to these features, you can organize your income and
          expenses and monitor your budget status with Toucan.
        </p>
        <p>
          It is currently live on the Google Play Store and you can also use the
          Toucan on the web.
        </p>
      </div>

      <!-- <a
        href="https://play.google.com/store/apps/details?id=org.cordova.quasar.toucan"
        class="btn"
        target="_blank"
        >google play store</a
      > -->
      <!-- <div class="button-container">
        <div>
          <a
            href="https://play.google.com/store/apps/details?id=org.cordova.quasar.toucan"
            target="_blank"
          >
            <img src="@/assets/images/google-play-badge.png" alt="" />
          </a>
        </div>
        <div>
          <a href="https://toucanx.vercel.app" target="_blank" class="myButton"
            >toucan web site</a
          >
        </div>
      </div> -->
      <div class="button-container">
        <a
          href="https://play.google.com/store/apps/details?id=org.cordova.quasar.toucan"
          target="_blank"
          ><img src="@/assets/images/google-play-badge.png" alt=""
        /></a>
        <a href="https://toucanx.vercel.app" class="toucan-btn" target="_blank"
          ><img src="@/assets/images/toucanXsvg.svg" alt="" class="img" />
          toucan web</a
        >
      </div>
    </div>

    <div class="image">
      <!-- <img src="@/assets/images/home-img.png" alt="" /> -->
      <!-- <img src="@/assets/images/toucan.webp" alt="" /> -->
      <Slide />
    </div>
    <!-- SLIDER -->
  </section>
</template>
<script>
import Slide from "./Slide.vue";

export default {
  components: { Slide },
};
</script>
<style scoped>
.button-container {
  margin-top: 2.6rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: transparent;
  /* border: 1px solid; */
  text-align: center;
  height: 50px;
}
.button-container a {
  width: 20rem;
  /* border: 1px solid; */
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
}
.button-container a img {
  /* width: 40px; */
  width: 100%;
  height: 80px;
}
.toucan-btn {
  border: 3px solid;
  border-radius: 10px;
  cursor: pointer;
  background: #3dc21b;
}
.toucan-btn .img {
  width: 60px;
  margin-right: 2rem;
}
.toucan {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.toucan .image {
  flex: 1 1 20rem;
}

.toucan .image img {
  width: 100%;
}

.toucan .content {
  flex: 1 1 40rem;
}

.toucan .content .hi {
  font-size: 2rem;
  color: var(--main-color);
}

.toucan .content h3 {
  font-size: 4.5rem;
  color: #111;
  text-transform: uppercase;
}

.toucan .content h3 span {
  color: var(--main-color);
  text-transform: uppercase;
}

.toucan .content .info {
  font-size: 2.5rem;
  color: #111;
  padding: 0.5rem 0;
}

.toucan .content .text {
  font-size: 1.7rem;
  color: #666;
  padding: 0.5rem 0;
}
</style>
